import { render, staticRenderFns } from "./sToolbarAgreementPerson.vue?vue&type=template&id=4f542b1c"
import script from "./sToolbarAgreementPerson.vue?vue&type=script&lang=js"
export * from "./sToolbarAgreementPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports